import domReady from '@wordpress/dom-ready';

domReady(() => {
  const statsBlocks = document.querySelectorAll('.stats-block');

  const animateValue = (element, start, end, duration) => {
    const startTime = performance.now();
    const isDecimal = end.toString().includes('.');
    const decimalPlaces = isDecimal ? end.toString().split('.')[1].length : 0;

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function for smooth animation
      const easeOutQuad = progress * (2 - progress);
      const current = start + (end - start) * easeOutQuad;

      element.textContent = isDecimal
        ? current.toFixed(decimalPlaces)
        : Math.floor(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        element.textContent = isDecimal ? end.toFixed(decimalPlaces) : end;
      }
    };

    requestAnimationFrame(animate);
  };

  const parseValue = (str) => {
    // Extract numeric value from string (handles +20, 100, 48.5, etc.)
    const match = str.match(/([+-]?\d+\.?\d*)/);
    return match ? parseFloat(match[1]) : 0;
  };

  const observerOptions = {
    threshold: 0.3,
    rootMargin: '0px',
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const statsItems = entry.target.querySelectorAll('.stats-block__value');

        statsItems.forEach((item) => {
          const numberElement = item.querySelector('.stats-block__number');
          const targetValue = item.getAttribute('data-target');
          const numericValue = parseValue(targetValue);

          animateValue(numberElement, 0, numericValue, 2000);
        });

        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  statsBlocks.forEach((block) => {
    observer.observe(block);
  });
});
